import { lruMemoize } from 'reselect';

import type { FilesProxySchemaWithIdNullable } from '@iconik-io/iconik-api/src/services/files';

import { getIsDropFrame } from './get_is_drop_frame';
import { getProxyFrameRate } from './get_proxy_frame_rate';

export type TimecodeOptions = {
  frameRate: number;
  isDropFrame: boolean;
  // To support non-zero-based start timecode
  startTimecode: string | undefined;
};

export const getProxyTimecodeOptions = lruMemoize(
  (proxy: FilesProxySchemaWithIdNullable): TimecodeOptions => {
    const frameRate = getProxyFrameRate(proxy) ?? 25;
    const dropFrameValue = proxy.is_drop_frame ?? false;
    const isDropFrame = getIsDropFrame(frameRate, dropFrameValue);
    return {
      frameRate,
      isDropFrame,
      startTimecode: proxy.start_time_code ?? undefined,
    };
  },
);
